import { filledInputClasses, inputBaseClasses, inputLabelClasses } from '@mui/material';
import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiTextField: Components<Omit<Theme, 'components'>>['MuiTextField'] = {
  defaultProps: {
    variant: 'filled',
    hiddenLabel: true,
    InputLabelProps:{ shrink: true },
  },
  styleOverrides: {
    root: ({ ownerState }) => ({
      [`& .${filledInputClasses.root}`]: {
        paddingLeft: '12px',
        [`&.${inputBaseClasses.root}`]: {
          marginTop: 'auto',
        },
        [`& .${inputBaseClasses.input}`]: {
          padding: ownerState.size === 'medium' ? '12px' : '',
        },
      },
      [`& .${inputLabelClasses.filled}`]: {
        transform: 'unset',
        fontSize: '12px',
        position: 'unset',
        marginBottom: '8px',
      },
    }),
  },
};